<template>
  <div id="dashboard" class="dashboard">
    <Sidebar :tenant-url="tenantUrl" :sidebar-closed="sidebarClosed" @toggleSidebar="toggleSidebar" />
    <div id="scroll-mark" class="dashboard-main">
      <notifications group="notices" :classes="'vue-notification notification'" :duration="6000" />
      <div class="dashboard-main-scrim" :class="{ visible: !sidebarClosed }" @click="toggleSidebar" />
      <header class="dashboard-main-header" :class="{'dashboard-main-header-sidebar-open': !sidebarClosed}">
        <Navigation :tenant-url="tenantUrl" @toggleSidebar="toggleSidebar" />
      </header>
      <Main />
      <Footer />
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import Sidebar from "./components/Sidebar.vue";
import Main from "../shared/components/UI/Main.vue";
import Footer from "../shared/components/UI/Footer.vue";
import SidebarStore from "./components/Sidebar/Store";

export default {
  name: "App",

  components: {
    Navigation,
    Sidebar,
    Main,
    Footer
  },

  data () {
    return {
      sidebarState: SidebarStore.state,
      currentTenant: Dashboard.currentTenant
    };
  },

  computed: {
    tenantUrl () {
      return this.currentTenant.logo.url;
    },

    sidebarClosed () {
      return this.sidebarState.sidebarClosed;
    }
  },

  methods: {
    toggleSidebar: function () {
      SidebarStore.toggleSidebar();
    }
  }
};
</script>
